import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, useNavigate, useParams } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import Container from 'react-bootstrap/Container';
import CalendarPage from './components/CalendarPage';
import FullCalendarPage from './components/FullCalendarPage';
import Chihuahua from './components/ChihuahuaElement';
import './App.css';

// Component to handle navigation in the main App
function AppContent() {
  const [activeView, setActiveView] = useState<'home' | 'calendar' | 'fullCalendar'>('home');
  const navigate = useNavigate();
  const location = useLocation();

  // Determine text colors based on background
  const homeTextColor = '#000000'; // Consistent black text for readability

  // Listen for navigateToDate event from FullCalendarPage
  useEffect(() => {
    const handleNavigateToDate = (event: any) => {
      const { date } = event.detail;
      navigate(`/calendar/${date}`);
    };

    window.addEventListener('navigateToDate', handleNavigateToDate);

    return () => {
      window.removeEventListener('navigateToDate', handleNavigateToDate);
    };
  }, [navigate]);

  // Update activeView based on route
  useEffect(() => {
    if (location.pathname.startsWith('/calendar')) {
      setActiveView('calendar');
    } else if (location.pathname.startsWith('/full-calendar')) {
      setActiveView('fullCalendar');
    } else {
      setActiveView('home');
    }
  }, [location.pathname]);

  return (
    <div className="App">
      {/* Navigation Bar - 山水流觞风格 */}
      <Navbar
        bg="light"
        variant="light"
        expand="lg"
        style={{
          background: 'linear-gradient(135deg, rgba(200, 225, 210, 0.95) 0%, rgba(170, 200, 195, 0.9) 40%, rgba(190, 215, 220, 0.92) 100%)',
          boxShadow: '0 2px 8px rgba(0,0,0,0.08), inset 0 -1px 0 rgba(255,255,255,0.5)',
          backdropFilter: 'blur(10px)',
          borderBottom: '1px solid rgba(255, 255, 255, 0.6)',
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        {/* 山水装饰底层 */}
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1440 60'%3E%3Cpath fill='%23ffffff' fill-opacity='0.15' d='M0,32L48,34.7C96,37,192,43,288,45.3C384,48,480,48,576,42.7C672,37,768,27,864,26.7C960,27,1056,37,1152,40C1248,43,1344,37,1392,34.7L1440,32L1440,60L1392,60C1344,60,1248,60,1152,60C1056,60,960,60,864,60C768,60,672,60,576,60C480,60,384,60,288,60C192,60,96,60,48,60L0,60Z'%3E%3C/path%3E%3C/svg%3E")`,
            backgroundSize: 'cover',
            backgroundPosition: 'bottom',
            pointerEvents: 'none',
            zIndex: 0,
          }}
        />
        <Container style={{ position: 'relative', zIndex: 1 }}>
          <Navbar.Brand
            href="#home"
            onClick={(e: React.MouseEvent) => {
              e.preventDefault();
              navigate('/');
            }}
            style={{
              color: '#3a6b4f',
              fontWeight: 'bold',
              fontFamily: '"KaiTi", "楷体", serif',
              fontSize: '1.4rem',
              textShadow: '1px 1px 2px rgba(255,255,255,0.8)',
              letterSpacing: '2px',
            }}
          >
            🏞️ poem的日历
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
              <Nav.Link
                href="#home"
                onClick={(e: React.MouseEvent) => {
                  e.preventDefault();
                  navigate('/');
                }}
                style={{
                  color: '#4a7c64',
                  fontWeight: activeView === 'home' ? 'bold' : 'normal',
                  fontFamily: '"KaiTi", "楷体", serif',
                  fontSize: '1.05rem',
                  padding: '8px 16px',
                  borderRadius: '20px',
                  backgroundColor: activeView === 'home' ? 'rgba(255,255,255,0.4)' : 'transparent',
                  transition: 'all 0.3s ease',
                  margin: '0 2px',
                }}
              >
                🏠 首页
              </Nav.Link>
              <Nav.Link
                href="#calendar"
                onClick={(e: React.MouseEvent) => {
                  e.preventDefault();
                  navigate('/calendar');
                }}
                style={{
                  color: '#4a7c64',
                  fontWeight: activeView === 'calendar' ? 'bold' : 'normal',
                  fontFamily: '"KaiTi", "楷体", serif',
                  fontSize: '1.05rem',
                  padding: '8px 16px',
                  borderRadius: '20px',
                  backgroundColor: activeView === 'calendar' ? 'rgba(255,255,255,0.4)' : 'transparent',
                  transition: 'all 0.3s ease',
                  margin: '0 2px',
                }}
              >
                📅 今日日历
              </Nav.Link>
              <Nav.Link
                href="#full-calendar"
                onClick={(e: React.MouseEvent) => {
                  e.preventDefault();
                  navigate('/full-calendar');
                }}
                style={{
                  color: '#4a7c64',
                  fontWeight: activeView === 'fullCalendar' ? 'bold' : 'normal',
                  fontFamily: '"KaiTi", "楷体", serif',
                  fontSize: '1.05rem',
                  padding: '8px 16px',
                  borderRadius: '20px',
                  backgroundColor: activeView === 'fullCalendar' ? 'rgba(255,255,255,0.4)' : 'transparent',
                  transition: 'all 0.3s ease',
                  margin: '0 2px',
                }}
              >
                🗓️ 完整日历
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {/* Main Content */}
      <Container fluid className="main-content">
        <Routes>
          <Route path="/" element={
            <div
              className="home-page"
              style={{
                position: 'relative',
                minHeight: '100vh',
                backgroundImage: 'url(https://picsum.photos/seed/cartoon-animals/1600/900)',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                color: homeTextColor,
                fontFamily: '"KaiTi", "楷体", serif',
                padding: '40px 20px',
                overflow: 'auto'
              }}
            >
              {/* Overlay for softening the background */}
              <div
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  background: 'linear-gradient(135deg, rgba(232, 245, 232, 0.7) 0%, rgba(165, 214, 167, 0.7) 100%)',
                  zIndex: 0
                }}
              ></div>

              {/* Decorative Poem Background */}
              <div
                className="home-poem-background"
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  zIndex: 1,
                  pointerEvents: 'none',
                  overflow: 'hidden'
                }}
              >
                <div
                  style={{
                    fontSize: '5rem',
                    fontWeight: 'bold',
                    color: 'white',
                    opacity: 0.08,
                    textAlign: 'center',
                    transform: 'rotate(-15deg)',
                    fontFamily: 'serif'
                  }}
                >
                  春风十里不如你
                </div>
              </div>

              {/* 吉娃娃二妞 */}
              <Chihuahua
                position="top-left"
                size={90}
                opacity={0.85}
                variant={0}
              />
              <Chihuahua
                position="top-right"
                size={85}
                opacity={0.85}
                variant={1}
              />

              <Container className="text-center py-5" style={{ position: 'relative', zIndex: 1 }}>
                <h1 className="display-3 mb-4" style={{ 
                  color: homeTextColor,
                  fontFamily: '"LiSu", "隶书", "KaiTi", "楷体", serif',
                  fontWeight: 'bold',
                  textShadow: '2px 2px 4px rgba(0,0,0,0.1)'
                }}>
                  欢迎来到poem的日历
                </h1>
                <p className="lead mb-5" style={{ 
                  fontSize: '1.5rem', 
                  color: homeTextColor,
                  fontFamily: '"KaiTi", "楷体", serif'
                }}>
                  每一天都充满诗意与温暖
                </p>

                <div className="row justify-content-center">
                  <div className="col-md-6">
                    {/* Floating card container with 1.jpg background */}
                    <div
                      className="floating-cards-container"
                      style={{
                        position: 'relative',
                        zIndex: 1,
                        padding: '30px',
                        borderRadius: '24px',
                        backgroundImage: 'url(/1.jpg)',
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        boxShadow: '0 8px 32px rgba(0,0,0,0.2)',
                        border: '2px solid rgba(255,255,255,0.4)',
                        backdropFilter: 'blur(8px)',
                        animation: 'floatIn 0.6s ease-out'
                      }}
                    >
                      {/* Semi-transparent overlay */}
                      <div
                        style={{
                          position: 'absolute',
                          top: 0,
                          left: 0,
                          width: '100%',
                          height: '100%',
                          backgroundColor: 'rgba(255, 255, 255, 0.65)',
                          borderRadius: '22px',
                          zIndex: 0
                        }}
                      ></div>

                      {/* 每日祝福卡片 */}
                      <div
                        className="card shadow-lg mb-4 p-4"
                        style={{
                          position: 'relative',
                          zIndex: 1,
                          backgroundImage: 'url(/1.jpg)',
                          backgroundSize: 'cover',
                          backgroundPosition: 'center',
                          borderRadius: '20px',
                          border: '1px solid rgba(255, 255, 255, 0.7)',
                          backdropFilter: 'blur(10px)',
                          transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                          boxShadow: '0 8px 20px rgba(0,0,0,0.15)',
                          padding: '30px'
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.transform = 'translateY(-5px)';
                          e.currentTarget.style.boxShadow = '0 12px 24px rgba(0,0,0,0.2)';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = 'translateY(0)';
                          e.currentTarget.style.boxShadow = '0 8px 20px rgba(0,0,0,0.15)';
                        }}
                      >
                        {/* Card semi-transparent overlay */}
                        <div
                          style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            backgroundColor: 'rgba(255, 255, 255, 0.7)',
                            borderRadius: '20px',
                            zIndex: 0
                          }}
                        ></div>
                        <div style={{ position: 'relative', zIndex: 1 }}>
                          <h3 style={{
                            color: homeTextColor,
                            fontFamily: '"LiSu", "隶书", "KaiTi", "楷体", serif',
                            fontWeight: 'bold'
                          }}>
                            每日祝福
                          </h3>
                          <p style={{
                            color: homeTextColor,
                            fontFamily: '"KaiTi", "楷体", serif'
                          }}>
                            每天都有独特的祝福语，让温暖伴随你的每一天
                          </p>
                          <button
                            className="btn btn-success btn-lg mt-3"
                            onClick={() => navigate('/calendar')}
                            style={{
                              backgroundColor: '#43A047',
                              borderColor: '#43A047',
                              borderRadius: '30px',
                              fontWeight: 'bold',
                              fontFamily: '"LiSu", "隶书", "KaiTi", "楷体", serif',
                              color: '#FFFFFF',
                              padding: '12px 30px',
                              boxShadow: '0 4px 12px rgba(67, 160, 71, 0.4)',
                              transition: 'all 0.3s ease'
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.transform = 'translateY(-2px)';
                              e.currentTarget.style.boxShadow = '0 6px 16px rgba(67, 160, 71, 0.6)';
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.transform = 'translateY(0)';
                              e.currentTarget.style.boxShadow = '0 4px 12px rgba(67, 160, 71, 0.4)';
                            }}
                          >
                            进入今日日历
                          </button>
                        </div>
                      </div>

                      {/* 完整日历卡片 */}
                      <div
                        className="card shadow-lg p-4"
                        style={{
                          position: 'relative',
                          zIndex: 1,
                          backgroundImage: 'url(/1.jpg)',
                          backgroundSize: 'cover',
                          backgroundPosition: 'center',
                          borderRadius: '20px',
                          border: '1px solid rgba(255, 255, 255, 0.7)',
                          backdropFilter: 'blur(10px)',
                          transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                          boxShadow: '0 8px 20px rgba(0,0,0,0.15)',
                          padding: '30px'
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.transform = 'translateY(-5px)';
                          e.currentTarget.style.boxShadow = '0 12px 24px rgba(0,0,0,0.2)';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = 'translateY(0)';
                          e.currentTarget.style.boxShadow = '0 8px 20px rgba(0,0,0,0.15)';
                        }}
                      >
                        {/* Card semi-transparent overlay */}
                        <div
                          style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            backgroundColor: 'rgba(255, 255, 255, 0.7)',
                            borderRadius: '20px',
                            zIndex: 0
                          }}
                        ></div>
                        <div style={{ position: 'relative', zIndex: 1 }}>
                          <h3 style={{
                            color: homeTextColor,
                            fontFamily: '"LiSu", "隶书", "KaiTi", "楷体", serif',
                            fontWeight: 'bold'
                          }}>
                            完整日历
                          </h3>
                          <p style={{
                            color: homeTextColor,
                            fontFamily: '"KaiTi", "楷体", serif'
                          }}>
                            查看完整2026年日历，感受四季变化的诗意
                          </p>
                          <button
                            className="btn btn-outline-success btn-lg mt-3"
                            onClick={() => navigate('/full-calendar')}
                            style={{
                              borderColor: '#43A047',
                              color: '#2E7D32',
                              borderRadius: '30px',
                              fontWeight: 'bold',
                              fontFamily: '"LiSu", "隶书", "KaiTi", "楷体", serif',
                              padding: '12px 30px',
                              boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                              backgroundColor: 'rgba(255, 255, 255, 0.8)',
                              transition: 'all 0.3s ease'
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.transform = 'translateY(-2px)';
                              e.currentTarget.style.backgroundColor = 'rgba(67, 160, 71, 0.1)';
                              e.currentTarget.style.boxShadow = '0 6px 16px rgba(0,0,0,0.15)';
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.transform = 'translateY(0)';
                              e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.8)';
                              e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)';
                            }}
                          >
                            查看完整日历
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="mt-5" style={{ 
                  color: homeTextColor, 
                  fontFamily: '"KaiTi", "楷体", serif' 
                }}>
                  <p style={{ fontFamily: '"KaiTi", "楷体", "Xingkai", "行楷", serif' }}>由 豆同学 精心设计</p>
                </div>
              </Container>
            </div>
          } />
          <Route path="/calendar" element={<CalendarPage />} />
          <Route path="/calendar/:date" element={<CalendarPageWithDate />} />
          <Route path="/full-calendar" element={<FullCalendarPage />} />
        </Routes>
      </Container>
    </div>
  );
}

// Component to handle specific date in calendar
function CalendarPageWithDate() {
  const { date } = useParams<{ date: string }>();
  return <CalendarPage initialDate={date} />;
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;